import api from "api/axios";

const METHOD_BASE = "/lab-method";
const CALCULATION_BASE = "/lab-calculation";

const extractList = (payload) => {
  if (!payload) return [];
  if (Array.isArray(payload)) return payload;
  if (Array.isArray(payload?.data?.data)) return payload.data.data;
  if (Array.isArray(payload?.data)) return payload.data;
  return [];
};

const extractMeta = (payload, fallback) =>
  payload?.meta || payload?.data?.meta || fallback;

const pickErrorMessage = (error, fallback) =>
  error?.response?.data?.message || error?.message || fallback;

const listResource = async (base, params, fallbackMessage) => {
  try {
    const response = await api.get(base, { params });
    const payload = response?.data ?? {};
    const items = extractList(payload);
    return {
      ok: true,
      data: items,
      meta: extractMeta(payload, {
        page: params?.page || 1,
        perPage: params?.perPage || 20,
        total: items.length,
        totalPages: 1,
      }),
    };
  } catch (error) {
    return {
      ok: false,
      data: [],
      meta: { page: 1, perPage: params?.perPage || 20, total: 0, totalPages: 0 },
      error: pickErrorMessage(error, fallbackMessage),
    };
  }
};

const mutate = async (request, fallbackMessage) => {
  try {
    const response = await request();
    return { ok: true, data: response?.data?.data ?? response?.data ?? null };
  } catch (error) {
    return { ok: false, error: pickErrorMessage(error, fallbackMessage) };
  }
};

export const listLabMethods = (params = {}) =>
  listResource(METHOD_BASE, params, "Unable to load methods.");

export const createLabMethod = (payload) =>
  mutate(() => api.post(METHOD_BASE, payload), "Unable to create the method.");

export const updateLabMethod = (id, payload) =>
  mutate(
    () => api.patch(`${METHOD_BASE}/${id}`, payload),
    "Unable to update the method."
  );

export const deleteLabMethod = (id) =>
  mutate(
    () => api.delete(`${METHOD_BASE}/${id}`),
    "Unable to delete the method."
  );

export const listLabCalculations = (params = {}) =>
  listResource(CALCULATION_BASE, params, "Unable to load calculations.");

export const createLabCalculation = (payload) =>
  mutate(
    () => api.post(CALCULATION_BASE, payload),
    "Unable to create the calculation."
  );

export const updateLabCalculation = (id, payload) =>
  mutate(
    () => api.patch(`${CALCULATION_BASE}/${id}`, payload),
    "Unable to update the calculation."
  );

export const deleteLabCalculation = (id) =>
  mutate(
    () => api.delete(`${CALCULATION_BASE}/${id}`),
    "Unable to delete the calculation."
  );

export const getLabCalculationPresets = async () => {
  try {
    const response = await api.get(`${CALCULATION_BASE}/presets`);
    return extractList(response?.data);
  } catch {
    return [];
  }
};

export const evaluateLabCalculation = async (id, values) => {
  try {
    const response = await api.post(`${CALCULATION_BASE}/${id}/evaluate`, {
      values,
    });
    return { ok: true, data: response?.data?.data ?? null };
  } catch (error) {
    return {
      ok: false,
      error: pickErrorMessage(error, "Unable to evaluate the calculation."),
    };
  }
};

const optionList = async (base) => {
  try {
    const response = await api.get(base, {
      params: { activeOnly: true, perPage: 500 },
    });
    return extractList(response?.data);
  } catch {
    return [];
  }
};

export const getLabMethodOptions = () => optionList(METHOD_BASE);

export const getLabCalculationOptions = () => optionList(CALCULATION_BASE);
